import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { MembreComite } from '../model/membre-comite';

@Injectable({
    providedIn: 'root'
  })
  export class MembreComiteService{
  
    constructor(private _restClientService: RestClientService) {}

    getAllMembreComites() {
        return this._restClientService.load<MembreComite[]>("membre-comite/get");
    }
          
    getMembreComiteById(membreComiteId){
      return this._restClientService.load<MembreComite>("membre-comite/get/"+membreComiteId);
    }
          
    putMembreComite(membreComite) {
      return this._restClientService.put<MembreComite>(`membre-comite/update`, membreComite);
    }
    
    postMembreComite(membreComite) {
      return this._restClientService.save<MembreComite>('membre-comite/add', membreComite);
    }
    
    deleteMembreComite(membreComiteId){
      return this._restClientService.delete<void>('membre-comite/delete/'+membreComiteId);
    }

}      

    